import { schema } from 'normalizr';

export const route = new schema.Entity('routes', { idAttribute: 'id_hike' });
export const arrayOfRoutes = new schema.Array(route);

export const line = new schema.Entity('lines', { idAttribute: 'id' });
export const arrayOfLines = new schema.Array(line);

export const hike = new schema.Entity('hikes', { idAttribute: 'id' });
export const arrayOfHikes = new schema.Array(hike);

export const theme = new schema.Entity('themes', { idAttribute: 'id' });
export const arrayOfThemes = new schema.Array(theme);
theme.define({
    hikes: arrayOfHikes
})

export const step = new schema.Entity('steps', { idAttribute: 'id' });
export const arrayOfSteps = new schema.Array(step);